import { isGlobalworth, paths } from 'config'
import { DrawerZones, Zones } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.zones,
    admin: true,
    exact: true,
    linkSettings: {
      icon: isGlobalworth ? Zones : DrawerZones,
      label: 'nav.zones',
    },
    component: Loadable({
      component: () => import('./pages/Zones'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.addZone,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/AddZone'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.zone,
    admin: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/Zone'),
    }),
    layoutSettings: {},
  },
]

export default routes
